import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "base-page grid-box grid-col",
  id: "customers-pages"
}
const _hoisted_2 = {
  key: 1,
  class: "customer-view"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["customerList"], {
      class: "customer-list scroll-y",
      "selected-user": $setup.selectedUser,
      "onUpdate:selectedUser": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedUser) = $event)),
      slots: $setup.customers,
      onCreateCustomer: $setup.handlePopup
    }, null, 8, ["selected-user", "slots"]),
    ($setup.selectedUser)
      ? (_openBlock(), _createBlock($setup["customerDetails"], {
          key: 0,
          class: "customer-view scroll-y",
          selection: $setup.selectedUser,
          "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedUser) = $event)),
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectedUser=undefined))
        }, null, 8, ["selection"]))
      : _createCommentVNode("", true),
    (!$setup.selectedUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "warning" }, "Loading...", -1),
          _createElementVNode("div", { class: "loading-box" }, [
            _createElementVNode("div", { class: "loading-circle" })
          ], -1)
        ])))
      : _createCommentVNode("", true),
    ($setup.showCreateUser)
      ? (_openBlock(), _createBlock($setup["NewCustomerPopup"], {
          key: 2,
          "onUpdate:showPoup": _cache[3] || (_cache[3] = ($event: any) => ($setup.showCreateUser=false))
        }))
      : _createCommentVNode("", true)
  ]))
}